// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZW4X9","right":"styles_right__2QU28"};